<template>
  <container>
    <div class="container">
      <div class="faq-page page w-100 p-0 m-0">
        <div class="page__header">
          <h2>FAQ</h2>
        </div>
        <div class="page__card page__card--no-bg mt-0">
          <div class="page__card__content page__card__content--lg">
            <faq-list :limit="10" />
          </div>
        </div>
      </div>
    </div>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * FAQs page
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'
import FAQList from '@/components/lists/FAQList'

export default {
  metaInfo: function() {
    return {
      title: 'FAQ',
      meta: [
        {
          property: 'og:title',
          content: 'Frequently Asked Questions'
        }
      ]
    }
  },
  components: {
    container: MainLayout,
    'faq-list': FAQList
  }
}
</script>
